import {
  AfterContentChecked,
  Component,
  ContentChild,
  ContentChildren,
  Input,
  QueryList
} from "@angular/core";
import { TableColumnComponent } from "src/app/components/ui/table/table-column/table-column.component";

@Component({
  selector: "snt-table",
  templateUrl: "table.component.html",
  styleUrls: ["table.component.scss"],
  standalone: false
})
export class TableComponent<T> {
  @ContentChildren(TableColumnComponent)
  columns: QueryList<TableColumnComponent<T>> = new QueryList();

  @Input()
  dataSource: T[] = [];

  @Input()
  showedColumns: string[] = [];
}
